import { Tile, Container, Header, BodyText, Flyer } from "../components/";
import * as templates from "../../../assets/flyers";
import * as React from 'react';

export const Templates = (props) => (
    <div>
    <Header>Select your Flyer ✈️ ... get it?</Header>
    <BodyText animation={"fadeIn"}> 
      Choose wisely! Your clients will thank you later. Let me know if you need any help choosing. I have pretty good eye for design 🎨
  </BodyText>
    <Container animation={"fadeIn delay"}>
      {Object.keys(templates).map((flyer, i) => (
        <Tile
          animation={"perkUp"}
          route={`${props.route}/${flyer}`}
        >
          <Flyer size={"small"}>
            {templates[flyer]}
          </Flyer>
        </Tile>
      ))}
    </Container>
  </div>
)


// WEBPACK FOOTER //
// ./src/components/marketing/pages/templates.js